module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-dialog', {
    attrs: {
      "open": true,
      "title": "操作失败"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("当前剩余训练次数为0，请联系医院负责人购买训练次数!")]), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "slot": "actions",
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a64cb98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/timer/zeroLeft.vue
// module id = 969
// module chunks = 2